export class TopCms {
	id: number;
	idMarket: string;
	rank: number;
	cta: string;
	image: string;
	imageTablet: string;
	imageMobile: string;

	imageUrl: string;
	imageLink: string;
	imageUrlTablet: string;
	imageLinkTablet: string;
	imageUrlMobile: string;
	imageLinkMobile: string;

	lang: string;

	setImage(fileB64, ex = "") {
		if (this[`image${ex}`] = fileB64) {
			this[`imageUrl${ex}`] = `url(${this[`imageLink${ex}`] = `data:image/jpg;base64,${fileB64}`})`;
		}
	}
}